import {toast} from "react-toastify";
import {
  calculateSumOfEachRowSadan,
  calculateSumOfEachRowSadanJustSaleReturn,
  calculateSumOfEachRowSadanJustSellFactor
} from "../SellFactorFunctionsSadan";
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";
import {parseToEnRemoveComma} from "../../../utils/CommaSeparator";

export const prefixForBulk = 'bulk';
export const prefixForPackage = 'pack';
export const generateBarcodeList = (packageListName) => {
  // packageListName = [
  //   {value: 1, label: " پوستی ران ", packageList: [{value: 11, label: "بسته500گرمی"}]},
  //   {value: 2, label: " پوستی سینه ", packageList: [{value: 12, label: "بسته500گرمی"}]},
  //   {value: 3, label: " پوستی بال و کتف ", packageList: [{value: 13, label: "بسته500گرمی"}]},
  //   {value: 4, label: " بدون پوست بال و کتف ", packageList: [{value: 14, label: "بسته500گرمی"}]},
  // ];
  const temp = [];

  packageListName.forEach(row => {
    row.packageList.forEach(v => {
      temp.push({label: v.value, value: v.value})
    })
  })


  return temp
}
export const generateAllProductList = (bulkListName, packageListName) => {
  const t1 = addPrefixToValues(bulkListName, prefixForBulk);
  // const t2 = addPrefixToValues(packageListName, prefixForPackage)
  // return [...t1, ...t2]
  return t1
}
const addPrefixToValues = (arrayOfObjects, str) => {
  arrayOfObjects.forEach(v => {
    v.value = str + v.value
  })
  return arrayOfObjects;
}
const removePreFixFromValue = (value, str) => {
  const temp = value.replace(str, "")
  return temp
}
// const removePrefixFromArrayOfObject=(array)=>{
//   const temp = array.map(v=>{
//
//   })
// }

export const changeNameHandler = (e, setMyData) => {
  if (e?.packageList?.length > 0) {
    setMyData({
      showPackageTypeList: true,
      packageTypesList: e.packageList,
      selectedBarcodeValue: "",
      type: "",
      selectedPackageTypeName: "",

    })
  } else {
    const selectedBarcodeValue = removePreFixFromValue(e.value, prefixForBulk);
    setMyData({
      showPackageTypeList: false,
      packageTypesList: [],
      selectedBarcodeValue,
      type: prefixForBulk,
      selectedPackageTypeName: "",
    })
  }
}
export const changePackageTypeHandler = (e, setMyData) => {
  //debugger
  const val = e.value
  setMyData({
    selectedBarcodeValue: val,
    type: prefixForPackage
  });
}

export const barcodeInputChangeHandler = (e, setMyData) => {
  const val = e.target.value
  setMyData({selectedBarcodeValue: val, type: 'pack'})
}
export const addProductHandlerSadanShop = (e, componentData, mode, setSendData, sendData, myData, setMyData) => {
  // if checks
  let url = "";
  if (mode === 'remittance') {
    url = `/storeRemittance` + "/?request=productDetail&type=" + myData.type +
      "&value=" + myData.selectedBarcodeValue +
      "&storeId=" + componentData.currentStoreId
  }
  if (mode === 'buyReturn') {
    url = `/returnFromBuy/
?request=productDetail&
type=${myData.type}&
value=${myData.selectedBarcodeValue}
&storeId=${componentData.currentStoreId}
&factorId=${sendData.factorId}`

  }
  if (mode === "sell") {
    url = `/groceryStoreSellFactor/
?request=productDetail&
type=${myData.type}&
value=${myData.selectedBarcodeValue}
&storeId=${componentData.currentStoreId}`
  }
  if (mode === 'saleReturn') {

    // url = "/returnFromSale/?request=productList&factorId=" + sendData.factorId;
    url = `/returnFromSale/
?request=productDetail
&type=${myData.type}
&value=${myData.selectedBarcodeValue}
&storeId=${componentData.currentStoreId}
&factorId=${sendData.factorId}`

  }

  if (!componentData.currentStoreId) {
    toast.error(`لطفا یک  انبار انتخاب کنید.`)
    return
  }
  // همچنین باید اینجا چک کنم اگه از نوع نام بود رنگ و سایز باید پر شده باشه اگه پر نبود ارور میدم و برمیگردم
  _axios.get(prefixUrl() + url).then(res => {
    if (res.data.status) {
      let inputObject = res.data.data
      setMyData({selectedBarcodeValue: ''})
      addNewRowToPriceTableSadan(inputObject, componentData, mode, setSendData, sendData, myData, setMyData);
    } else {
      toast.error(res.data.message)
    }
  })
}

export const addNewRowToPriceTableSadan = (inputObject, componentData, mode, setSendData, sendData, myData, setMyData) => {


  const objectData = {...inputObject}
  if (mode === 'saleReturn') {
    objectData['returnToStore'] = (objectData['returnToStore'] === "yes")
  }

  // این آرایه ی پکس رو بک اند لازم داره و من اینجا تعریفش میکنم
  // و بعدا هم در جای مونرد نظر تکراری هاشو حذف میکنم و پوش میکنم
  //debugger
  objectData.packs = [myData.selectedBarcodeValue]


  //I know That productId is Uniq that backEnd Send to Front
  let tableData = [];
  // i must add StoreId and Store Name From ComponentData
  /// mode === "saleReturn" i use this information
  objectData.storeId = componentData.currentStoreId
  objectData.storeName = componentData.currentStoreName

  if (mode === "sell" && objectData.type === "pack") {
    // هر بسته فقط یه بار میتونه بیاد توی جدول قرار بگیره
    debugger
    if (packageIsinTable(sendData?.tableData, objectData.packId)) {
      const message = 'این بسته به جدول اضافه شده است';
      toast.info(message)
      return;
    }

  }

  if (mode === "remittance") {
    objectData.seriesId = "";
    if (componentData.destinationStoreId === undefined || componentData.destinationStoreName === undefined) {
      toast.error("انبار مقصد را انتخاب کنید")
      return
    }
    if (componentData.destinationStoreId === componentData.currentStoreId) {
      toast.error("انبار مبدا و مقصد نباید یکی باشد.")
      return
    }
    objectData.destinationStoreId = componentData.destinationStoreId
    objectData.destinationStoreName = componentData.destinationStoreName
  }


  let alreadyAdded = false;

  tableData = sendData?.tableData?.map(singleRow => {


    if (+singleRow.productId === +objectData.productId
      && +singleRow.storeId === +objectData.storeId
      && singleRow.type === objectData.type

    ) {
      if (singleRow.type === 'bulk') {

        singleRow.weight = +singleRow.weight + +objectData.weight
      } else if (singleRow.type === 'pack') {
        singleRow.number = +singleRow.number + +objectData.number
        singleRow.weight = +singleRow.weight + +objectData.weight
        // بک گفته  نباید این آرایه مقادیرش تکراری باشه
        singleRow.packs = [...singleRow.packs, ...objectData.packs]
        singleRow.packs = [...new Set(singleRow.packs)]
        // مرجوع از فروش یکم استثنا داره اول بررسی میشه بعدا میره سراغ بقیه
        if (mode === 'sell') {
          // محاسبه جمع کل در فاکتور فروش استثنا داره
          const last = singleRow?.total ? parseToEnRemoveComma(singleRow.total) : 0
          singleRow.total = +last + objectData.price;
          singleRow.price = (singleRow.total / singleRow.number)
        }
      }


      alreadyAdded = true
    }
    return singleRow
  }) || [];

  if (!alreadyAdded) {
    if (mode === "sell") {
      objectData.total = objectData.price;
    }
    tableData.push({...objectData})
  }
  // i need  To Add a uniqId
  // const row = utilsFunction.addUniqId({...objectData})
  // tableData = [...sendData.tableData, row];
  if (mode === 'sell') {
    tableData = calculateSumOfEachRowSadanJustSellFactor(tableData)
  } else if (mode === 'saleReturn') {
    tableData = calculateSumOfEachRowSadanJustSaleReturn(tableData)
  } else {
    tableData = calculateSumOfEachRowSadan(tableData)
  }
  // tableData = calculateSumOfEachRowSadan(tableData)
  setSendData({tableData})
  // i will calculate sumPrice  of them in effect of show table Component
}

function packageIsinTable(tableData, packId) {

  console.log(tableData);
  let isInTable = false;
  tableData.forEach(row => {
    if (row.packs.includes(packId.toString())) {
      isInTable = true
    }
  })

  // return tableData.find((v) => v['packId'] === packId)
  return isInTable;
}
